import { useMemo } from 'react'
import { WaitingRoom } from '@/core/models/waiting-room.model'
import { selectAuthUser } from '@/redux/reducers/auth.reducer'
import { useAppSelector } from '@/redux/rootReducer'

export function useWaitingRoomJoined(waitingRoom?: WaitingRoom) {
  const authUser = useAppSelector(selectAuthUser)
  return useMemo(() => !!waitingRoom?.doctors.find((doctor) => doctor === authUser?._id), [authUser, waitingRoom])
}
